import axiosInstance from '../axios/axios-instance';

export const ipTracking = {
  /**
   * Detects if the IP address has changed.
   *
   * @returns True if the IP address has changed, false otherwise
   */
  async detectIpChange(): Promise<boolean> {
    const response = await axiosInstance.get('/ip-tracking');
    return response.headers['x-ip-changed'] === 'true';
  },
};
